import { api } from './api'
import { KnowledgeSpace, Document } from '../types/knowledge-space'
import { PaginationParams, PaginatedResponse } from '../types/common'
export const knowledgeSpaceService = {
  /**
   * Fetches all knowledge spaces for the current user
   */
  getAll: async (): Promise<KnowledgeSpace[]> => {
    return api.get('/knowledge-spaces')
  },
  /**
   * Fetches a single knowledge space by ID
   */
  getById: async (id: string): Promise<KnowledgeSpace> => {
    return api.get(`/knowledge-spaces/${id}`)
  },
  /**
   * Creates a new knowledge space
   */
  create: async (data: Partial<KnowledgeSpace>): Promise<KnowledgeSpace> => {
    return api.post('/knowledge-spaces', data)
  },
  /**
   * Updates an existing knowledge space
   */
  update: async (id: string, data: Partial<KnowledgeSpace>): Promise<KnowledgeSpace> => {
    return api.put(`/knowledge-spaces/${id}`, data)
  },
  /**
   * Deletes a knowledge space
   */
  delete: async (id: string): Promise<void> => {
    return api.delete(`/knowledge-spaces/${id}`)
  },
  /**
   * Archives a knowledge space
   */
  archive: async (id: string): Promise<KnowledgeSpace> => {
    return api.put(`/knowledge-spaces/${id}/archive`, {})
  },
  /**
   * Restores an archived knowledge space
   */
  restore: async (id: string): Promise<KnowledgeSpace> => {
    return api.put(`/knowledge-spaces/${id}/restore`, {})
  },
  documents: {
    /**
     * Fetches paginated documents for a knowledge space
     */
    getAll: async (
      spaceId: string,
      params: PaginationParams,
    ): Promise<PaginatedResponse<Document>> => {
      return api.get(`/knowledge-spaces/${spaceId}/documents`, params as any)
    },
    /**
     * Uploads a new document to a knowledge space
     */
    upload: async (
      spaceId: string,
      file: File,
      metadata?: Partial<Document>,
    ): Promise<Document> => {
      const formData = new FormData()
      formData.append('file', file)
      if (metadata) {
        formData.append('metadata', JSON.stringify(metadata))
      }
      return api.post(`/knowledge-spaces/${spaceId}/documents`, formData)
    },
    /**
     * Updates document metadata
     */
    update: async (
      spaceId: string,
      documentId: string,
      data: Partial<Document>,
    ): Promise<Document> => {
      return api.put(`/knowledge-spaces/${spaceId}/documents/${documentId}`, data)
    },
    /**
     * Deletes a document
     */
    delete: async (spaceId: string, documentId: string): Promise<void> => {
      return api.delete(`/knowledge-spaces/${spaceId}/documents/${documentId}`)
    },
  },
}